import { Link } from "react-router-dom";
import { ArrowLeft, Calendar } from "lucide-react";
import { usePageSeo, BASE_URL } from "@/hooks/useSeo";
import SchedulerSection from "@/components/SchedulerSection";
import Navigation from "@/components/Navigation";

export default function TerminPage() {
  usePageSeo({
    title: "Termin buchen | LAB336",
    description: "Buchen Sie ein kostenloses 30-Minuten-Erstgespräch mit LAB336. Wir besprechen Ihre Herausforderungen in Prozessoptimierung, Digitalisierung oder KI.",
    canonical: `${BASE_URL}/termin`,
  });

  return (
    <div className="min-h-screen bg-white" data-testid="termin-page">
      <Navigation />
      <header className="bg-lab-bg-dark pt-24">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 py-12">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-lab-accent transition-colors text-sm mb-8" data-testid="back-to-home">
            <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
          </Link>
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 bg-white/10 flex items-center justify-center">
              <Calendar className="w-7 h-7 text-lab-accent" />
            </div>
            <div>
              <h1 className="font-playfair text-3xl lg:text-4xl font-semibold text-white">Termin buchen</h1>
              <p className="text-gray-400 mt-1">Kostenloses 30-Minuten-Erstgespräch</p>
            </div>
          </div>
        </div>
      </header>

      <SchedulerSection />

      <footer className="bg-lab-bg-dark border-t border-white/10">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 py-8 flex items-center justify-between">
          <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} LAB 336</p>
          <Link to="/" className="text-gray-400 hover:text-lab-accent text-sm">Startseite</Link>
        </div>
      </footer>
    </div>
  );
}
